import {Injectable} from '@angular/core';
import {Subject, Observable} from 'rxjs';
import {UserToken} from '../../models/security/user-token';
import {BaseStorageService} from '../storage/base-storage.service';
import {StorageService} from '../storage/storage.service';
import {DateService} from '../api-services/date.service';

/**
 * Servicio de almacenamiento de token de seguridad.
 */
@Injectable({
  providedIn: 'root',
})
export class SecurityTokenStorage<T extends UserToken> extends BaseStorageService<T> {
  /**
   * Si la sesión está expirada, se emite el evento de sesión expirada.
   */
  private OnSessionExpired = new Subject<UserToken>();

  /**
   * Constructor.
   * @ignore
   */
  constructor(storageService: StorageService) {
    super(storageService);
  }

  /**
   * Si el login está expirado o no.
   * @param userToken
   * @returns
   */
  private static loginExpired(userToken: UserToken) {
    return DateService.datetimeIsBefore(DateService.getDate(userToken.tokenExpirationDate), DateService.currentDate());
  }

  /**
   * Si la sesión está expirada, se emite el evento de sesión expirada.
   * @returns
   */
  public onSessionExpired(): Observable<any> {
    return this.OnSessionExpired;
  }

  /**
   * Función para obtener la clave de almacenamiento.
   * @returns
   */
  protected getStorageKey(): string {
    return 'eyesnroad-acceptedLogin';
  }

  /**
   * Función de login correcto.
   * @returns
   */
  public getAcceptedLogin(): UserToken {
    const userToken = super.getObjectValue();
    if (userToken) {
      if (!SecurityTokenStorage.loginExpired(userToken)) {
        return userToken;
      } else {
        this.OnSessionExpired.next(userToken);
      }
    }
    return null;
  }
}
